import { addDays } from "date-fns";


export const IsCompleteTime =(instance) =>{
    return instance.match(/^\d{2}:\d{2}$/);
}


export const TimeStringToMinutes = (timeStr) => {
    if (!timeStr || timeStr.trim() === '') return 0; 
    
    return (Number(timeStr) === timeStr)
        ? Number(timeStr)
        : (Number(timeStr.substring(0, 2)) * 60 + Number(timeStr.substring(3)));
};

export const CalculateTotalMinutes = (startTime, endTime, breakTime) => {
    const startMinutes = TimeStringToMinutes(startTime);
    const endMinutes = TimeStringToMinutes(endTime);
    const breakMinutes = TimeStringToMinutes(breakTime);

    return endMinutes - startMinutes - breakMinutes;
};

export const DifferenceInMinutes = (first, second)=>{

    var firstInput = (Number(first)===first ) ? Number(first) : ((Number(first.substring(0,2)) * 60) + Number(first.substring(3)));
    var secondInput = (Number(second)===second ) ? Number(second) : ((Number(second.substring(0,2)) * 60) + Number(second.substring(3)));

    return  firstInput -secondInput;

}

const formatHours = (value) => {
  return parseFloat(value.toFixed(2)).toString();
};

export const formatDisplayDate = (totalMinutes, dateToggle, totalMin = false) => {

  let hour;
  let minute;
    if(totalMin === true){
        const hour = totalMinutes;
        const minute = Math.round((totalMinutes - Math.floor(totalMinutes)) * 60);
        if (dateToggle){
            return  `${hour > 0 ? `${Math.floor(hour)}hr` : ""} ${minute > 0 ? `${minute}min` : ""}`;
        }
        else{
            return  hour > 0 ? `${formatHours(hour)}hr` : "";
        }
    }
  if (dateToggle) {
    
    // Logic for "Xhr Ymin"
    hour = Math.floor(Math.trunc((totalMinutes / 60) * 100) / 100);
    minute = Math.trunc((totalMinutes % 60) * 100) / 100;
    
    return `${hour > 0 ? `${Math.floor(hour)}hr` : ""}  ${minute > 0 ? `${minute}min` : ""}`;
  } else {
    // Logic for "X.XXhr"
    hour = Math.round((totalMinutes / 60) * 100) / 100;
    
    return hour > 0 ? `${formatHours(hour)}hr` : "";
  }
};

export const getHourTotals = (timesheetData, leaveData, currentWeekStart) =>{
   const dates = Array.from({ length: 7 }, (_, i) => addDays(currentWeekStart, i));
  
    // Compute daily totals
    const dailyWorkTotals = dates.map((date) => {
      let totalMinutes = 0;
      
      if (!timesheetData) return;

      timesheetData.forEach((client) => {
        client.projects.forEach((project) => {
          project.budgets.forEach((budget) => {
            budget.timecodes.forEach((timecode) => {
              timecode.entryDays.forEach((entry) => {
                if (entry.date.toString() === date.toString() && entry.status !== "empty" && entry.status !== "error") {
                  totalMinutes += entry.entries.reduce((sum, e) => sum + e.totalMinutes, 0);
                }
              });
            });
          });
        });
      });
      return (totalMinutes / 60 * 100) / 100;
    });
  
  
    const leaveTotals = dates.map((date) => {
      let totalHours = 0;
      (leaveData || []).forEach((ld) => {
          if(new Date(ld.date).toDateString() === date.toDateString()){
            totalHours += ld.hours;
          }
      });
      return (totalHours * 100) / 100;
    }); 
  
    const dailyTotals = dailyWorkTotals.map((dt,index) => dt + leaveTotals[index]);
  
    // Compute weekly total
    let weekTotal = dailyTotals.reduce((sum, dayTotal) => sum + dayTotal, 0);

    return{ weekTotal: weekTotal, dailyTotals: dailyTotals}

}